<template>
    <div class="day_edit" :class="{ one_day: isOverlay }" :style="styleString" ref="content" v-if="isShow" v-click-outside="action_ClickOutside">
        <div class="day" v-if="isOverlay">
            <span class="date">{{ dateString }}</span>
            <div class="mgl_auto">
                <button class="btn btn_xxs btn_blue" @click="action_Save">{{ $t('common.save') }}</button>
                <button class="btn btn_xs ico btn_white" @click="action_Close">
                    <v-icon>mdi-close</v-icon>
                </button>
            </div>
        </div>

        <div class="code_item_wrap" :class="{ isOverlay: isOverlay }" ref="codeItemWrap">
            <EditItem
                v-for="(record, index) in modifiedRecords"
                :ref="'EditItem' + index"
                :key="index"
                :value="record"
                :index="index"
                :isOverlay="isOverlay"
                :keyEventController="keyEventController"
                @updateValue="updateValue"
                @removeRecord="removeRecord"
            />
        </div>

        <div class="btn_wrap" v-if="isShowCustomTimeCode || !isOverlay">
            <button class="btn_xxs w_full" @click="action_ShowCustomTimeOverlay">＋ {{ $t('work_schedule.calendar.label_custom_time') }}</button>
            <CustomTimeOverlay :date="date" @addCustomWorkRecord="addCustomWorkRecord" />
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { workerState, setModifiedRecords, hideCalendarEditLayer, showCustomTimeOverlay, hideCustomTimeOverlay, showSearchLayer } from '../../../../worker-state'
import _ from 'lodash'
const moment = require('@/util/MPMoment')
import EditItem from './CalendarEditItem.vue'
import CustomTimeOverlay from './CustomTimeOverlay.vue'
import { useV2WorkRecordUpdateMutation } from '@/composables/queries/v2workrecord/use-v2-workrecord-update-mutation'
import { useV2WorkRecordSendPushMutation } from '@/composables/queries/v2workrecord/use-v2-workrecord-send-push-mutation'

export default {
    setup() {
        const { mutateAsync: updateWorkRecord } = useV2WorkRecordUpdateMutation()
        const { mutateAsync: sendPushWorkRecord } = useV2WorkRecordSendPushMutation()
        return { updateWorkRecord, sendPushWorkRecord }
    },
    components: { EditItem, CustomTimeOverlay },
    props: {
        isOverlay: Boolean,
        date: Object,
        records: Array,
        keyEventController: Object
    },
    data() {
        return {
            worker: workerState,
            positionX: 0,
            positionY: 0,

            modifiedRecords: undefined,
            removalRecords: [],
            originRecordSnapshots: {}
        }
    },
    watch: {
        isShow: {
            deep: true,
            handler: function (newValue) {
                if (this.isEditMode != true) {
                    if (newValue == true) {
                        this.registKEC()
                    } else {
                        this.unregistKEC()
                    }
                }

                if (newValue != true) {
                    this.unregistAlert()
                    this.worker.focusedElement = undefined
                    this.updateModifiedRecords()
                    return
                } else {
                    this.initRecords()
                    this.registAlert()
                    this.$nextTick(() => {
                        this.updateFrame()
                    })
                }
            }
        },
        isModified: {
            handler: function () {
                this.updateModifiedRecords()
            }
        },
        records: {
            handler: function () {
                this.initRecords()
            }
        }
    },
    computed: {
        isShow: function () {
            if (this.isOverlay == true) {
                return this.worker.calendarEditLayer_Date?.format() == this.date?.format()
            }
            return this.isEditMode
        },
        isEditMode: function () {
            return this.worker.isModifyMode
        },
        dateString: function () {
            return this.date.format('D')
        },
        styleString: function () {
            return 'top: ' + this.positionY + 'px; left: ' + this.positionX + 'px;'
        },
        originCodes: function () {
            return this.worker.workCodes
        },
        hasEmployeeRecord: function () {
            return this.modifiedRecords.filter((r) => r.employees != undefined && r.employees.length > 0)
        },
        isModified: function () {
            if (this.modifiedRecords == undefined || this.modifiedRecords?.length == 0) {
                return false
            }
            let originEmployeesRecords = this.worker.originRecords.filter((r) => (r.employees?.filter((employee) => employee.isRemoved === false)?.length ?? 0) > 0)
            for (let i = 0; i < this.modifiedRecords.length; i++) {
                let mr = this.modifiedRecords[i]
                let or = originEmployeesRecords.find(
                    (r) =>
                        r.isCustomized == mr.isCustomized &&
                        r.date == mr.date &&
                        r.workCodeID?._id == mr.workCodeID?._id &&
                        moment(r.startedAt).format('HH:mm') == moment(mr.startedAt).format('HH:mm') &&
                        moment(r.endedAt).format('HH:mm') == moment(mr.endedAt).format('HH:mm')
                )
                if (or == undefined) {
                    if (mr.employees?.length != 0) {
                        return true
                    }
                    continue
                }
                let mrEmployees = mr.employees
                let orEmployees = or.employees
                if (_.isEqual(mrEmployees, orEmployees) != true) {
                    return true
                }
            }
            return false
        },
        focusedRecord: function () {
            return this.worker.focusedRecord
        },
        isShowCustomTimeCode: function () {
            return this.worker.isShowCustomTimeCode
        },
        isShowSearchLayer: function () {
            for (let i = 0; i < this.modifiedRecords.length; i++) {
                let elArray = this.$refs['EditItem' + i]
                let el = elArray[0]
                if (el != undefined) {
                    if (el.isShowSearchLayer == true) {
                        return true
                    }
                }
            }
            return false
        }
    },
    destroyed() {
        this.unregistAlert()
        this.unregistKEC()
    },
    methods: {
        action_ClickOutside(e) {
            if (this.AlertController.currentAlert != undefined) { return }
            if (e.target.classList.contains('mdi-close')) return
            if (this.isEditMode) return
            if (this.isShowSearchLayer == true) return

            this.worker.focusedRecord = undefined
            this.worker.focusedElement = undefined
            this.worker.searchLayer_Key = undefined
            this.close()
        },
        action_Close() {
            this.worker.focusedRecord = undefined
            this.worker.focusedElement = undefined
            this.worker.searchLayer_Key = undefined
            this.close()
        },
        async action_Save() {
            await this.saveRecords()
            this.worker.focusedRecord = undefined
            this.worker.focusedElement = undefined
            this.worker.searchLayer_Key = undefined
            this.worker.needUpdateRecords = true
            this.close(true)
        },
        action_ShowCustomTimeOverlay() {
            showCustomTimeOverlay(this.date)
        },

        // MARK: - Private
        initRecords() {
            let array = []
            for (let i = 0; this.originCodes && i < this.originCodes.length; i++) {
                let hospitalID = this.hospital.selectedHospital._id
                let code = this.originCodes[i]
                let record = this.records.find((r) => r.workCodeID?._id == code._id)
                if (record == undefined) {
                    record = {
                        hospitalID: hospitalID,
                        date: this.date.format(),
                        employees: [],
                        workCodeID: code
                    }
                }
                let currentCode = this.worker.workCodes.find((c) => c._id == code._id)
                record.isSelected = currentCode.isSelected
                record.employees = record.employees.filter((employee) => employee.isRemoved === false)

                array.push(record)
            }
            let customs = this.records.filter((c) => c.isCustomized == true)
            if (customs.length != 0) {
                for (let i = 0; i < customs.length; i++) {
                    let record = customs[i]
                    record.isSelected = this.worker.isShowCustomTimeCode
                }
                array = array.concat(deepCopy(customs))
            }

            this.modifiedRecords = array
            this.removalRecords = []
            // 변경분만 update 하기 위한 편집 전 스냅샷 (직원 구성 + 시간)
            this.originRecordSnapshots = {}
            for (const record of array) {
                this.originRecordSnapshots[this.recordSnapshotKey(record)] = this.recordSnapshot(record)
            }
            this.updateModifiedRecords()
        },
        recordSnapshotKey(record) {
            return record._id ?? `new:${record.workCodeID?._id}`
        },
        recordSnapshot(record) {
            const employeeIds = (record.employees ?? []).map((e) => e._id).sort().join(',')
            return `${employeeIds}|${record.startedAt ?? ''}|${record.endedAt ?? ''}`
        },
        isRecordModified(record) {
            const origin = this.originRecordSnapshots?.[this.recordSnapshotKey(record)]
            // 스냅샷이 없으면(예외 상황) 기존처럼 전송해 저장 누락을 막는다
            if (origin == undefined) { return true }
            return origin != this.recordSnapshot(record)
        },
        updateFrame() {
            let endOfWeek = moment(this.date).endOf('week').startOf('day')
            let date = moment(this.date).startOf('day')
            this.positionX = 0
            if (date.toString() == endOfWeek.toString()) {
                this.positionX = -20
            }

            let height = this.$refs?.content?.offsetHeight ?? 0
            let parentRect = this.$refs.content?.parentElement?.parentElement?.getBoundingClientRect() ?? {}
            let parentTop = parentRect?.top ?? 0
            let grandParentHeight = this.$refs.content?.parentElement?.parentElement?.parentElement?.parentElement?.offsetHeight ?? 0
            this.positionY = 0
            if (grandParentHeight - (parentTop + height) < 0) {
                this.positionY = grandParentHeight - parentTop - height
            }
        },
        updateValue(record, index) {
            this.modifiedRecords.splice(index, 1, record)
            this.updateModifiedRecords()
        },
        updateModifiedRecords() {
            let key = this.date.format()
            let data = {
                modifiedRecords: this.modifiedRecords,
                removalRecords: deepCopy(this.removalRecords),
                isModified: this.isModified
            }
            setModifiedRecords(key, data)
        },

        registAlert() {
            if (this.isOverlay != true) {
                return
            }
            this.AlertController.registAlert(this, 'ScheduleSaveAlert', {
                usingCloseButton: true,
                usingAlertTag: true,
                text: '설정한 일정으로 적용할까요?',
                lButtonTitle: '저장 안함',
                rButtonTitle: '저장',
                checksum: this.checkSaveAlert,
                cHandler: this.alertLeftHandler,
                lHandler: this.alertLeftHandler,
                rHandler: this.alertRightHandler
            })
        },
        unregistAlert() {
            if (this.isOverlay != true) {
                return
            }
            this.AlertController.unregistAlert(this, 'ScheduleSaveAlert')
        },
        async showSaveAlert() {
            let result = await this.AlertController.showAlert(this, 'ScheduleSaveAlert')
            if (result == 'close') {
                return
            }
            this.close(true)
        },
        alertLeftHandler() {},
        async alertRightHandler() {
            await this.action_Save()
        },

        // MARK: - Event Handle

        registKEC() {
            let routerObj = this.keyEventController.getNextRouteObject('keydown', 'scroll')
            routerObj.groupKey = 'keydown_keyinput'
            routerObj.target = this._uid
            routerObj.policy = this.keyEventController.Enum.RoutingPolicy.Stop
            routerObj.handler = this.handleKeyEvent
            this.keyEventController.registRouter(routerObj)
        },
        unregistKEC() {
            this.keyEventController.unregistRouter(this._uid)
        },
        handleKeyEvent(e) {
            let key = e.key
            let addIndex = 0

            if (key === 'ArrowUp') {
                addIndex = -1
            }
            if (key === 'ArrowDown') {
                addIndex = 1
            }
            if (key === 'Escape') {
                if (this.AlertController.currentAlert != undefined) {
                    this.AlertController.hideAlert()
                    return
                }
                if (!this.isEditMode && this.worker.searchLayer_Key == undefined && this.worker.customTimeOverlay_Date == undefined) {
                    this.action_Close()
                }
            }

            let record = undefined
            let index = -1
            if (this.focusedRecord == undefined) {
                record = this.modifiedRecords[0]
                index = 0
            } else {
                index = this.modifiedRecords.indexOf(this.focusedRecord)
                index += addIndex
                if (index < 0 || index >= this.modifiedRecords.length) {
                    return
                }
                record = this.modifiedRecords[index]
            }

            this.$nextTick(() => {
                this.worker.focusedRecord = record
                this.scrollFocusedElementIntoView(index)

                // Add 'focused' class to the focused element
                if (!this.$refs.codeItemWrap) return

                const elements = this.$refs.codeItemWrap.querySelectorAll('.code_item')

                if (elements) {
                    elements.forEach((el) => el.classList.remove('focused'))
                    if (elements[index]) {
                        elements[index].classList.add('focused')
                    }
                }
            })

            if (key === 'Enter') {
                let searchLayerKey = {
                    _id: record._id,
                    hospitalID: record.hospitalID,
                    date: record.date,
                    workCodeID: record.workCodeID,
                    isCustomized: record.isCustomized,
                    startedAt: record.startedAt,
                    endedAt: record.endedAt
                }
                this.$nextTick(() => {
                    showSearchLayer(searchLayerKey)
                })
            }
        },

        scrollFocusedElementIntoView(index) {
            if (this.$refs.codeItemWrap) {
                const codeItemWrap = this.$refs.codeItemWrap
                const elements = codeItemWrap.querySelectorAll('.code_item')
                if (elements && elements[index]) {
                    const element = elements[index]
                    const elementRect = element.getBoundingClientRect()
                    const containerRect = codeItemWrap.getBoundingClientRect()

                    if (elementRect.top < containerRect.top) {
                        // Scroll up
                        codeItemWrap.scrollTop -= containerRect.top - elementRect.top
                    } else if (elementRect.bottom > containerRect.bottom) {
                        // Scroll down
                        codeItemWrap.scrollTop += elementRect.bottom - containerRect.bottom
                    }
                }
            }
        },

        // MARK: - Network
        async saveRecords() {
            this.isLoading = true
            let promises = []
            for (let i = 0; i < this.modifiedRecords.length; i++) {
                let record = this.modifiedRecords[i]
                // 변경분만 update — 직원 구성/시간이 편집 전과 같으면 요청을 보내지 않는다
                // (기존에는 근무코드 수만큼, 빈 employees 신규 레코드까지 전부 전송했음)
                if (!this.isRecordModified(record)) { continue }
                let p = this.updateRecords(record)
                promises.push(p)
            }
            for (let i = 0; i < this.removalRecords.length; i++) {
                let record = this.removalRecords[i]
                let p = this.removeRecords(record)
                promises.push(p)
            }
            // await 하지 않으면 action_Save 가 저장 완료 전에 needUpdateRecords 를 세워
            // 재조회가 저장 전 캐시를 읽는다 (staleTime 0 시절엔 매번 네트워크라 가려져 있던 race)
            try {
                const results = await Promise.all(promises)
                // 변경이 없으면 푸시도 보내지 않는다
                if (results.length > 0) {
                    this.sendPush(results)
                }
            } catch (err) {
                console.log(err)
            } finally {
                this.isLoading = false
            }
        },
        async updateRecords(data) {
            let model = {}
            if (data._id == undefined) {
                model = deepCopy(data)
                model.employees = data.employees.map((e) => e._id)
                model.workCodeID = data.workCodeID?._id
            } else {
                model = {
                    _id: data._id,
                    hospitalID: data.hospitalID,
                    date: data.date,
                    workCodeID: data.workCodeID?._id,
                    employees: data.employees.map((e) => e._id),
                    startedAt: data.startedAt,
                    endedAt: data.endedAt
                }
            }
            model.isCustomized = data.isCustomized ?? false
            model.isRemoved = false
            // 봉투 에러(code != 0)는 ApiError로 reject — Promise.all의 catch에서 로그 (기존 동작 동일)
            return this.updateWorkRecord(model)
        },
        async removeRecords(data) {
            let model = {
                _id: data._id,
                hospitalID: data.hospitalID,
                date: data.date,
                isCustomized: true,
                startedAt: data.startedAt,
                endedAt: data.endedAt,
                isRemoved: true
            }
            // 봉투 에러(code != 0)는 ApiError로 reject — Promise.all의 catch에서 로그 (기존 동작 동일)
            return this.updateWorkRecord(model)
        },
        async sendPush(results) {
            // mutateAsync는 봉투를 해제한 workRecord 객체를 반환한다
            let ids = results.map((r) => {
                return r._id
            })
            ids = JSON.stringify(ids)
            let startedAt = moment(this.date).startOf('days')
            let endedAt = moment(this.date).endOf('days')
            let model = {
                data: {
                    hospitalID: this.hospital.selectedHospital._id,
                    startDate: startedAt.format(),
                    endDate: endedAt.format(),
                    workCodeIDs: ids
                }
            }
            this.sendPushWorkRecord(model).catch((err) => console.log(err))
            this.worker.lastBatchPushNotification = {
                hospitalID: this.hospital.selectedHospital._id,
                startDate: startedAt.format(),
                endDate: endedAt.format()
            }
        },

        // MARK: - Emit
        addCustomWorkRecord(record) {
            let customizedArray = this.modifiedRecords.filter((r) => r.isCustomized == true)
            let oldOne = customizedArray.find(
                (r) =>
                    moment(r.startedAt).hour() == moment(record.startedAt).hour() &&
                    moment(r.startedAt).minute() == moment(record.startedAt).minute() &&
                    moment(r.endedAt).hour() == moment(record.endedAt).hour() &&
                    moment(r.endedAt).minute() == moment(record.endedAt).minute()
            )
            if (oldOne != undefined) {
                return
            }
            record.isSelected = true
            this.modifiedRecords.push(record)
            this.updateModifiedRecords()
        },
        removeRecord(_, index) {
            let record = this.modifiedRecords.splice(index, 1)
            this.removalRecords = this.removalRecords.concat(record)
            this.updateModifiedRecords()
        },
        checkSaveAlert() {
            return this.isModified == false
        },
        close(isForceClose = false) {
            if (this.isModified && isForceClose == false) {
                this.showSaveAlert()
                return
            }
            hideCustomTimeOverlay()
            hideCalendarEditLayer()
        }
    }
}
</script>

<style scoped>
.v2_rsv .schedule .schedule_calendar_wrap .day_wrap .day_edit .code_item_wrap {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0;
}
.v2_rsv .schedule .schedule_calendar_wrap .day_wrap .day_edit .code_item_wrap.isOverlay {
    height: 100%;
    max-height: 470px;
}

.v2_rsv .schedule .schedule_calendar_wrap .day_wrap .day_edit .btn_wrap button {
    background-color: white;
    border: 1px solid var(--gray80);
    color: var(--gray100);
    /* 20260526 지호
        시간 직접 설정 버튼 스타일 수정
    */
}
.v2_rsv .schedule .schedule_calendar_wrap .day_wrap .day_edit .btn_wrap button:hover {
    background-color: var(--gray50);
    /* 20260526 지호
        시간 직접 설정 버튼 스타일 수정
    */
}
</style>
